export const ReminderAmountOfTimeEnum = [{
        key: 1,
        value: 'minutes',
        momentKey: 'minutes',
      }
];
